module.exports = __webpack_public_path__ + "static/how-to-create-brand-fac5409bcd119440bf881676af6b0474.png";